import { Link } from 'react-router-dom';
import { companyInfo } from '../data/siteData';

export default function FloatingCTA() {
  const ctaButtons = [
    {
      id: 'gold',
      label: 'Sælg dit guld',
      type: 'internal',
      href: '/vi-koeber-guld-og-soelv',
      icon: 'fa-solid fa-coins',
      color: 'bg-[#0B132B] text-[#D4AF37] border border-[#D4AF37]/50 shadow-lg hover:bg-[#D4AF37] hover:text-[#0B132B] hover:border-[#D4AF37]',
      badge: true,
    },
    {
      id: 'phone',
      label: `Ring: ${companyInfo.phone}`,
      type: 'external',
      href: `tel:${companyInfo.phoneRaw}`,
      icon: 'fa-solid fa-phone',
      color: 'bg-[#0B132B] text-white border border-white/20 hover:bg-[#8C7A5B] hover:border-[#8C7A5B]',
    },
    {
      id: 'email',
      label: `E-mail: ${companyInfo.email}`,
      type: 'external',
      href: `mailto:${companyInfo.email}`,
      icon: 'fa-solid fa-envelope',
      color: 'bg-[#0B132B] text-white border border-white/20 hover:bg-[#8C7A5B] hover:border-[#8C7A5B]',
    },
    {
      id: 'instagram',
      label: 'Følg os på Instagram',
      type: 'external',
      href: companyInfo.instagramUrl,
      icon: 'fa-brands fa-instagram',
      color: 'bg-[#0B132B] text-white border border-white/20 hover:bg-gradient-to-tr hover:from-[#f09433] hover:via-[#dc2743] hover:to-[#bc1888] hover:border-transparent',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
    {
      id: 'facebook',
      label: 'Følg os på Facebook',
      type: 'external',
      href: companyInfo.facebookUrl,
      icon: 'fa-brands fa-facebook-f',
      color: 'bg-[#0B132B] text-white border border-white/20 hover:bg-[#1877F2] hover:border-[#1877F2]',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  ];

  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-5 right-4 sm:right-6 z-50 flex flex-col gap-2.5 items-end"
    >
      {ctaButtons.map((btn) => {
        const buttonClass = `group relative flex items-center justify-center w-11 h-11 sm:w-12 sm:h-12 rounded-full shadow-xl transition-all duration-300 ease-out hover:scale-110 active:scale-95 cursor-pointer backdrop-blur-md ${btn.color}`;

        const innerContent = (
          <>
            {/* Centered Icon */}
            <i className={`${btn.icon} text-base sm:text-lg transition-transform duration-300 group-hover:scale-110`} aria-hidden="true" />

            {/* Smooth Tooltip on Hover (Desktop) */}
            <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-lg bg-[#0B132B]/95 px-3 py-1.5 text-[11px] font-medium uppercase tracking-wider text-white shadow-xl border border-white/10 opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0 translate-x-2 hidden sm:block">
              {btn.label}
            </span>
          </>
        );

        if (btn.type === 'internal') {
          return (
            <Link
              key={btn.id}
              to={btn.href}
              className={buttonClass}
              aria-label={btn.label}
            >
              {innerContent}
            </Link>
          );
        }

        return (
          <a
            key={btn.id}
            href={btn.href}
            target={btn.target}
            rel={btn.rel}
            className={buttonClass}
            aria-label={btn.label}
          >
            {innerContent}
          </a>
        );
      })}
    </aside>
  );
}
